// extracted by mini-css-extract-plugin
module.exports = {"accordion":"styles_accordion__6YItT","closed":"styles_closed__KXaYB","batched":"styles_batched__bpwu5","expanded":"styles_expanded__jvb_k"};